export interface Disclosure {
    DisclosureName: string;
    DisclosureMessage: string;
    DisclosureLink?: string;
    applicableTo: {
        outcomeTypes: string[];
        lineOfBusinesses: string[];
        stateCodes: string[];
        sources: string[];
        primaryOutcomeTypes: string[];
        isRPMAuthorization?: boolean;
    };
}

export const getDisclosures = (
    outcomeType?: string,
    lineOfBusiness?: string | string[],
    stateCode?: string,
    source?: string,
    primaryOutcomeType?: string | string[],
    isRPMAuthorization?: boolean
): Disclosure[] => {
    const allDisclosures: Disclosure[] = [
        {
            DisclosureName: "Fraud Statement",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Credit Disclosure",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Advised of Inspection",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: ["Business Owner's Policy"],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "RPM Authorization",
            DisclosureMessage: "",
            DisclosureLink: "https://geicoinsurance.lightning.force.com/lightning/articles/Knowledge/RPM-Handling-Commercial",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Completed SharePoint",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["NICO",
                          "BHHC"
                ],
                primaryOutcomeTypes: [],
                isRPMAuthorization: true
            },
        },
        {
            DisclosureName: "Agreement Disclaimer",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["TRAVELERS"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: true
            },
        },
        {
            DisclosureName: "New Business Closing Statement",
            DisclosureMessage: "I Will now process of your payment of [$XX], on your [card/account] ending in [XXXX], to start your [product] policy with [company] with an effective date of [effective date]",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "NY Disclosures",
            DisclosureMessage: "I am an employee of the GEICO Insurance Agency and licensed to sell insurance and offer you advice regarding this purchase. The GEICO Insurance Agency is licensed to sell insurance in the State of New York and will be compensated by the insurer who issues your policy. In addition to commission, depending upon the insurer you select, the Agency may receive additional compensation based on the contract it may have with that insurer. Upon request, additional information regarding the potential compensation the Agency could recieve from this sale can be provided.",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: ["NY"],
                sources: ["BIBERK", "HOMESITE", "HISCOX", "HARTFORD", "LIBERTYMUTUAL", "TRAVELERS", "UTICA", "RYAN_SPECIALTY", "NICO" ,"BHHC", "COVERWHALE", "CNA_SURETY", "NEXT"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "NY Disclosures",
            DisclosureMessage: "I am an employee of GEICO and licensed to sell insurance and offer you advice regarding this purchase. Upon request, additional information regarding the potential compensation I could reveive this sale can be provided.",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: ["NY"],
                sources: ["GEICO_ICLIQ", "GEICO_SSP"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Advised Liability Only",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["NICO", "BHHC", "COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Any Previous Insurance?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["NICO", "BHHC"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Surplus Lines Disclosure",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: [],
                lineOfBusinesses: ["E&S"],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Advised Driver Safety Program?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Advised General Agency Fee?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Docusign Complete?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "First Payment Complete?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "NBUS Documents Provided?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Onboarded into Application?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Contact & TPA Information Provided?",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale", "Follow-Up"],
                lineOfBusinesses: [],
                stateCodes: [],
                sources: ["COVERWHALE"],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Advise PH of onsite building inspection",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Sale"],
                lineOfBusinesses: ["Business Owner's Policy"],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: [],
                isRPMAuthorization: false
            },
        },
        {
            DisclosureName: "Verified Previous Commercial Auto Policies",
            DisclosureMessage: "",
            applicableTo: {
                outcomeTypes: ["Quote"],
                lineOfBusinesses: ["Commercial Auto"],
                stateCodes: [],
                sources: [],
                primaryOutcomeTypes: ["Not sold (offered to the customer)"],
                isRPMAuthorization: false
            },
        }
    ];

    return allDisclosures.filter((disclosure) => {
        const { outcomeTypes, lineOfBusinesses, stateCodes, sources, primaryOutcomeTypes, isRPMAuthorization: requiredRPMAuthorization } = disclosure.applicableTo;

        const matchesOutcomeType =
            outcomeTypes.length === 0 || outcomeTypes.includes(outcomeType ?? "");

        const lobArray = Array.isArray(lineOfBusiness) ? lineOfBusiness : (lineOfBusiness ? [lineOfBusiness] : []);
        const matchesLineOfBusiness =
            lineOfBusinesses.length === 0 || 
            (lobArray.length > 0 && lobArray.some(lob => lineOfBusinesses.includes(lob)));

        const matchesStateCode =
            stateCodes.length === 0 || stateCodes.includes(stateCode ?? "");

        const matchesSource =
            sources.length === 0 || sources.includes(source ?? "");

        const matchesRPMAuthorization =
            requiredRPMAuthorization === isRPMAuthorization;

        const primaryOutcomeTypeArray = Array.isArray(primaryOutcomeType) ? primaryOutcomeType : (primaryOutcomeType ? [primaryOutcomeType] : []);
        const matchesprimaryOutcomeType =
            primaryOutcomeTypes.length === 0 || 
            (primaryOutcomeTypeArray.length > 0 && primaryOutcomeTypeArray.some(outcome => primaryOutcomeTypes.includes(outcome)));

        return (
            matchesOutcomeType &&
            matchesLineOfBusiness &&
            matchesStateCode &&
            matchesSource &&
            matchesprimaryOutcomeType &&
            (requiredRPMAuthorization ? matchesRPMAuthorization : true)
        );
    });
};

const TELEMATICS_ALL_PROGRAMS = new Set(["DriveEasyProELD", "DriveEasyProOBD2", "DriveEasyProDashcam"]);
const TELEMATICS_ELD_HARDWARE_PROGRAMS = new Set(["DriveEasyProOBD2", "DriveEasyProDashcam"]);

const mkTelematicsDisclosure = (name: string): Disclosure => ({
    DisclosureName: name,
    DisclosureMessage: "",
    applicableTo: {
        outcomeTypes: [],
        lineOfBusinesses: [],
        stateCodes: [],
        sources: [],
        primaryOutcomeTypes: [],
        isRPMAuthorization: false
    }
});

const getHardwareProgram = (programType: string): string => {
    if (programType === "DriveEasyProOBD2") return "OBD";
    if (programType === "DriveEasyProDashcam") return "Dashcam";
    return "";
};

const buildEldDisclosures = (hardwareProgram: string, telematicsSelection?: string): Disclosure[] => {
    const result: Disclosure[] = [
        mkTelematicsDisclosure("Did you read the ELD DriveEasy Pro headset alert?"),
        mkTelematicsDisclosure("Did you attempt objection handling for the ELD program?"),
        mkTelematicsDisclosure(`Did you introduce the ${hardwareProgram} program?`)
    ];
    if (telematicsSelection === "yes") {
        result.push(mkTelematicsDisclosure(`Did you read the ${hardwareProgram} DriveEasy Pro headset alert?`));
    }
    if (telematicsSelection === "no") {
        result.push(mkTelematicsDisclosure(`Did you attempt objection handling for ${hardwareProgram}?`));
    }
    return result;
};

export const getTelematicsDisclosures = (
    hasElectronicLoggingDevice?: string,
    telematicsProgramType?: string,
    telematicsSelection?: string,
    source?: string
): Disclosure[] => {
    const isGEICOSource = source?.includes("GEICO") ?? false;
    if (!isGEICOSource) {
        return [];
    }
    if (!telematicsProgramType || !TELEMATICS_ALL_PROGRAMS.has(telematicsProgramType)) {
        return [];
    }

    const disclosures: Disclosure[] = [];
    const hardwareProgram = getHardwareProgram(telematicsProgramType);

    // AC1: ELD=Yes AND program is OBD2 or Dashcam
    if (hasElectronicLoggingDevice === "yes" && TELEMATICS_ELD_HARDWARE_PROGRAMS.has(telematicsProgramType)) {
        disclosures.push(...buildEldDisclosures(hardwareProgram, telematicsSelection));
    }

    // AC4: ELD=No AND any telematics program
    if (hasElectronicLoggingDevice === "no" && TELEMATICS_ALL_PROGRAMS.has(telematicsProgramType)) {
        disclosures.push(mkTelematicsDisclosure("Did you read the DriveEasy Pro headset alert?"));
        if (telematicsSelection === "no") {
            disclosures.push(mkTelematicsDisclosure("Did you attempt objection handling?"));
        }
    }

    // AC5: Any telematics program AND TelematicsSelection=Yes
    if (telematicsSelection === "yes") {
        disclosures.push(mkTelematicsDisclosure("Did you read all post-bind DriveEasy Pro disclosures before ending the call?"));
    }

    return disclosures;
};